import React, {useMemo, useState} from 'react';
import {useIntl} from 'react-intl';
import {useTable} from "react-table";
import {useHistory} from 'react-router-dom';
import * as actions from '../../_redux/actions/PriceQuotesPageTableActions';
import * as columnFormatters from '../../../_common/column-formatters';
import * as customColumnFormatters from '../column-formatters';
import {usePriceQuotesPageContext} from '../PriceQuotesPageContext';
import useInfiniteScrollControl from '../../../_common/components/_custom-hooks/useInfiniteScrollControl';
import CommonGrid from "../../../_common/components/CommonGrid";
import CommonGridSpinner from '../../../_common/components/CommonGridSpinner';
import SortingColumnHeader from "../../../_common/components/SortingColumnHeader/SortingColumnHeader";

export function PriceQuotesPageTable() {
  const intl = useIntl();
  const history = useHistory();
  const [tableRows, setTableRows] = useState([]);
  const prefix = 'price-quotes-page-column';
  const columns = useMemo(() => [
    {
      accessor: 'priceQuoteID',
      Header:
        <SortingColumnHeader
          text={intl.formatMessage({id: `${prefix}-id`, defaultMessage: 'ID'})}
          fieldName={'priceQuoteID'}
          useContext={usePriceQuotesPageContext}
        />
    },
    {
      accessor: 'createDate',
      Header:
        <SortingColumnHeader
          text={intl.formatMessage({id: `${prefix}-createDate`, defaultMessage: 'Create date'})}
          fieldName={'createDate'}
          useContext={usePriceQuotesPageContext}
          showDefaultIcon={true}
        />
    },
    {
      accessor: 'customers',
      Header:
        <SortingColumnHeader
          text={intl.formatMessage({id: `${prefix}-customers`, defaultMessage: 'Customers'})}
          fieldName={'customers'}
          useContext={usePriceQuotesPageContext}
        />
    },
    {
      accessor: 'contact',
      Header:
        <SortingColumnHeader
          text={intl.formatMessage({id: `${prefix}-contact`, defaultMessage: 'Contact'})}
          fieldName={'contact'}
          useContext={usePriceQuotesPageContext}
        />
    },
    {
      accessor: 'priceQuoteStatusName',
      Header:
        <SortingColumnHeader
          text={intl.formatMessage({id: `${prefix}-status`, defaultMessage: 'Status'})}
          fieldName={'priceQuoteStatusName'}
          useContext={usePriceQuotesPageContext}
        />
    },
    {
      accessor: 'price',
      Header:
        <SortingColumnHeader
          text={intl.formatMessage({id: `${prefix}-price`, defaultMessage: 'Price'})}
          fieldName={'price'}
          useContext={usePriceQuotesPageContext}
        />
    },
    {
      accessor: 'sent',
      Header:
        <SortingColumnHeader
          text={intl.formatMessage({id: `${prefix}-sent`, defaultMessage: 'Sent'})}
          fieldName={'sent'}
          useContext={usePriceQuotesPageContext}
        />
    },
    {
      accessor: 'customerStatus',
      Header:
        <SortingColumnHeader
          text={intl.formatMessage({id: `${prefix}-customerStatus`, defaultMessage: 'Customer status'})}
          fieldName={'customerStatus'}
          useContext={usePriceQuotesPageContext}
        />
    },
    {
      accessor: 'actions',
      Header: '',
      width: 90
    },
  ], []);
  const data = tableRows.map((item) => {
    return {
      priceQuoteID: columnFormatters.BoldColumnFormatter(item.priceQuoteID, 'xl'),
      createDate: columnFormatters.DateColumnFormatter(item.createDate),
      customers: columnFormatters.CustomersColumnFormatter(item.customers),
      contact: columnFormatters.BoldColumnFormatter([item.contactFirstName, item.contactLastName].filter(Boolean).join(' ')),
      priceQuoteStatusName: customColumnFormatters.PriceQuoteStatusColumnFormatter(item),
      price: columnFormatters.PriceColumnFormatter(item.price),
      sent: customColumnFormatters.SentColumnFormatter(item),
      customerStatus: customColumnFormatters.CustomerStatusColumnFormatter(item),
      actions: customColumnFormatters.PriceQuotesActionsColumnFormatter(item, {history}),
    };
  })

  const infiniteScrollProps = useInfiniteScrollControl({
    currentStateStoreId: 'priceQuotesPageTableReducer',
    UIContext: usePriceQuotesPageContext(),
    getNewEntities: actions.getPriceQuotes,
    getNextEntities: actions.getNextPriceQuotes,
    onEntitiesChange: entities => {
      entities
        ? setTableRows(entities)
        : setTableRows([])
    },
    startRequestedPageNumber: 0,
    dataLength: tableRows.length,
    scrollableTarget: 'scrollContainer',
    scrollThreshold: 0.9,
    loader: (<CommonGridSpinner/>),
    style: {
      overflow: 'inherit'
    },
  });

  return (
    <CommonGrid
      infiniteScrollProps={infiniteScrollProps}
      {...useTable({columns, data})}
    />
  );
}

export default PriceQuotesPageTable;